<template>
  <aside class="sidebar d-flex flex-column justify-content-between gap-5">
    <ul class="nav nav-pills flex-column">
      <SidebarItem
        v-for="route in routes"
        :key="route.path"
        :item="route"
      />
    </ul>

    <SidebarFooter />
  </aside>
</template>

<script setup>
import SidebarItem from '@/components/sidebar/sidebarItem.vue'
import SidebarFooter from '@/components/sidebar/sidebarFooter.vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { computed } from 'vue'

const $router = useRouter()
const userStore = useUserStore()
const visibilityCheck = r => r.meta?.sidebar === true && userStore.can(r.meta.rbac)
const routes = computed(() =>
  $router.options.routes.filter(r => {
    const sidebarChildren = (r.children || []).filter(c => c.meta?.sidebar === true)
    if (sidebarChildren.length) {
      return sidebarChildren.some(visibilityCheck)
    }
    return visibilityCheck(r)
  })
)
</script>
